import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

const isSimpleFooter = (path: string) => {
  // NOTE: path에 따라 simple footer 출력
  switch (path) {
    case 'start':
    case 'copy':
    case 'payment':
      return false;
  }
  return true;
};

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const lastSegment = location.pathname.split('/').at(-1);

  return (
    <LayoutContainer>
      <Main>{children}</Main>
      {/* {!isSimpleFooter(lastSegment) && <Footer />}
      {isSimpleFooter(lastSegment) && <SimpleFooter />} */}
    </LayoutContainer>
  );
}

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  background-color: ${({ theme }) => theme.color[1]};
`;

const Main = styled.main`
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
